import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';;
import ChartDataLabels from 'chartjs-plugin-datalabels';;

ChartJS.register(
  CategoryScale,
  ChartDataLabels,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend

);

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
    tooltipEl.style.borderRadius = '5px';
    tooltipEl.style.background = '#2A2E33';
    tooltipEl.style.color = 'white';
    tooltipEl.style.width = '303.4px';
    tooltipEl.style.height = '120.4px';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.top = '4rem';
    tooltipEl.style.display = 'flex';
    tooltipEl.style.justifyContent = 'center';
    tooltipEl.style.textTransform = 'capitalize';

    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';

    const table = document.createElement('table');
    table.style.margin = '0px';
    table.style.textAlign = 'center';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};


const externalTooltipHandler = (context) => {
  // Tooltip Element
  const {
    chart,
    tooltip,
  } = context;

  const tooltipEl = getOrCreateTooltip(chart);

  if (chart.tooltip._active && chart.tooltip._active.length) {
    const ctx = chart.ctx;
    ctx.save();
    const activePoint = chart.tooltip._active[0];
    ctx.beginPath();
    ctx.moveTo(activePoint.element.x, activePoint.element.y);
    ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#A2CCB7';
    ctx.stroke();
    ctx.restore();
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines);



    const tableHead = document.createElement('span');
    tableHead.style.margin = "auto";
    tableHead.style.fontSize = "16px";
    tableHead.style.color = "#fff";

    titleLines.forEach(title => {
      const tr = document.createElement('tr');
      tr.style.textAlign = "center";
      tr.style.borderWidth = 0;

      const th = document.createElement('th');
      th.style.borderWidth = 0;
      const text = document.createTextNode(title);
      th.appendChild(text);


      tr.appendChild(th);

      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement('tbody');
    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i];

      const span = document.createElement('span');
      span.style.display = 'inline-block';
      span.style.textAlign = 'center';

      const tr = document.createElement('p');
      tr.style.backgroundColor = '';
      tr.style.color = colors.borderColor;
      tr.style.borderWidth = 0;
      tr.style.fontSize = "16px";
      tr.style.margin = "0px";


      const td = document.createElement('td');
      td.style.borderWidth = 0;
      td.style.color = colors.borderColor;
      td.style.padding = 0

      const text = document.createTextNode(body);


      td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');
    tableRoot.style.position = 'relative';

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const {
    offsetLeft: positionX,
    offsetTop: positionY
  } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};


export default externalTooltipHandler;